import { numberFormat } from '~/lib/utils/number';

interface Props {
  total: number;
  offset: number;
  perPage: number;
}

export const PaginationSummary = ({ total, offset, perPage }: Props) => {
  const from = offset + 1;
  let to = offset + perPage;
  if (to > total) {
    to = total;
  }

  return (
    <div className="text-xs text-muted-foreground">
      <strong>
        {numberFormat(from)}-{numberFormat(to)}
      </strong>{' 件目を表示'}
      {' / '}
      <strong>{numberFormat(total)}</strong>{' 件'}
    </div>
  );
};
